// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-picksfor-partners-apply-js": () => import("./../../../src/pages/PicksforPartners/apply.js" /* webpackChunkName: "component---src-pages-picksfor-partners-apply-js" */),
  "component---src-pages-picksfor-partners-index-js": () => import("./../../../src/pages/PicksforPartners/index.js" /* webpackChunkName: "component---src-pages-picksfor-partners-index-js" */),
  "component---src-pages-policy-js": () => import("./../../../src/pages/policy.js" /* webpackChunkName: "component---src-pages-policy-js" */),
  "component---src-pages-terms-js": () => import("./../../../src/pages/terms.js" /* webpackChunkName: "component---src-pages-terms-js" */),
  "component---src-pages-terms-partners-js": () => import("./../../../src/pages/terms_partners.js" /* webpackChunkName: "component---src-pages-terms-partners-js" */)
}

